/* eslint-disable @typescript-eslint/no-explicit-any */
import { crabDevice } from '@hfzq/crab-utils';
import { Message } from '@src/helper/message';
import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { urlAddQuery } from '@src/helper/tools';
import { getCommonConfig } from '../zz-api/get-common-config';

/**
 * 数据中为null 和 undefined的值
 */
function filteObjectEmptyKey(params: unknown) {
  if (typeof params !== 'object' || !params) {
    return params;
  }
  const copy = JSON.parse(JSON.stringify(params));
  const filter = (data: Record<string, unknown> | unknown[]) => {
    if (typeof data !== 'object' || !data) {
      return;
    }
    if (Array.isArray(data)) {
      data.forEach((item: any) => {
        filter(item);
      });
      return;
    }

    Object.keys(data).forEach((key) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const val = (data as any)[key];
      if (val === undefined || val === null) {
        // eslint-disable-next-line no-param-reassign, @typescript-eslint/no-explicit-any
        delete (data as any)[key];
        return;
      }
      filter(val);
    });
  };
  filter(copy);
  return copy;
}

export interface ApiRequestConfig<T = unknown> extends AxiosRequestConfig<T> {
  autoLoading?: boolean;
}

interface CreateApidefaultConfig {
  cancelAuth?: boolean;
}

/**
 * 创建接口调用函数
 *
 * @param instance axios 实例
 * @param defaultConfig 默认配置
 */
export function createApiPostCall(instance: AxiosInstance, defaultConfig?: CreateApidefaultConfig) {
  return async <T>(url: string, data: unknown = {}, apiRequestConfig?: ApiRequestConfig): Promise<T> => {
    const { autoLoading = true, ...config } = apiRequestConfig || {};
    return handleLoading(autoLoading, async () =>
      instance.post(url, filteObjectEmptyKey(data || {}), {
        ...defaultConfig,
        ...config,
        baseURL: await handleBaseUrl(apiRequestConfig?.baseURL),
      })
    );
  };
}

/**
 * 创建接口调用函数
 *
 * @param instance axios 实例
 * @param defaultConfig 默认配置
 */
export function createApiGetCall(instance: AxiosInstance, defaultConfig?: Record<string, any>) {
  return async <T>(url: string, data: unknown = {}, apiRequestConfig?: ApiRequestConfig): Promise<T> => {
    const { autoLoading = true, ...config } = apiRequestConfig || {};
    return handleLoading(autoLoading, async () =>
      instance.get(urlAddQuery(url, filteObjectEmptyKey(data || {})), {
        ...defaultConfig,
        ...config,
        baseURL: await handleBaseUrl(apiRequestConfig?.baseURL),
      })
    );
  };
}

/**
 * 根据环境处理baseUrl
 * 在小福牛中需要拼接请求域名
 *
 * @param base baseUrl
 */
const handleBaseUrl = async (base?: string) => {
  let baseURL = '';
  if (process.env.NODE_ENV === 'production' && crabDevice.isTZT) {
    const { FUNDLINK } = await getCommonConfig();
    baseURL = FUNDLINK + (base || '');
  } else {
    baseURL = base || '';
  }
  return baseURL;
};

const handleLoading = async <T>(autoLoading: boolean, asyncCall: () => Promise<T>): Promise<T> => {
  try {
    if (autoLoading) {
      Message.addLoading();
    }
    return await asyncCall();
  } finally {
    if (autoLoading) {
      Message.removeLoading();
    }
  }
};
